<div
  class="card card-md border-0"
  [ngClass]="isLoading ? 'skeleton-loader' : 'loaded'">
  <div class="card-body d-grid">
    <div class="row">
      <div class="col-auto">
        <div
          class="icon-rounded text-white bg-secondary"
          [ngClass]="{ 'loading': isLoading }">
          <i class="pays-icon ic-rand-up"></i>
        </div>
      </div>
      <div class="col">
        <div>
          <div
            class="badge rounded-pill mb-1 bg-secondary"
            [ngClass]="{ 'loading': isLoading }">
            All cards
          </div>
        </div>
        <div>
          <div
            class="fw-medium title"
            [ngClass]="{ 'loading': isLoading }">
            Average monthly spend
            <i
              ngbTooltip="Average monthly spend is calculated on the previous 3 months' transactions."
              placement="bottom"
              tooltipClass="custom-tooltip"
              class="ms-2 text-dark iconoir-info-circle"></i>
          </div>
        </div>
        <div>
          <div
            class="amounts"
            id="aveMonthlySpend"
            [ngClass]="{ 'loading min-w-100': isLoading }">
            {{ averageSpend?.avg_spend | currency: 'ZAR' : 'symbol-narrow' | emptyIndicator }}
          </div>
        </div>
      </div>
    </div>
    <hr />
    <div class="mt-auto img-container">
      <img
        ngSrc="./assets/dashboard/Reports-ComingSoon-Banner.svg"
        fill
        alt="Report coming soon" />
    </div>
  </div>
</div>
